import { defineComponent as _defineComponent } from 'vue'
import { Navigation, Pagination } from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'Events',
  setup(__props, { expose: __expose }) {
  __expose();

const modules = [Navigation, Pagination]

const breakpoints = {
  0: {
    slidesPerView: 1,
    autoHeight: true,
  },
  564: {
    slidesPerView: 2,
    autoHeight: false,
  },
  1200: {
    slidesPerView: 3,
    spaceBetween: 30,
  },
  1620: {
    slidesPerView: 4,
  },
}

const __returned__ = { modules, breakpoints, get Navigation() { return Navigation }, get Pagination() { return Pagination } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})